import { CSSProperties, PropsWithChildren } from "react";
import { ReactComponent as Close } from "../images/close.svg";

const ModalOverlay: CSSProperties = {
  zIndex: "9999",
  width: "100vw",
  height: "100vh",
  position: "fixed",
  top: "0",
  left: "0",
  background: "rgba(150, 150, 150, 0.7)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const ModalBox: CSSProperties = {
  width: "800px",
  background: "white",
  display: "block",
  padding: "1rem"
};

const ModalContent: CSSProperties = {
  width: "100%",
};

type ModalType = {
  isOpen: boolean;
  toggle: () => void;
  buttonText?: string;
  buttonStyling?: CSSProperties,
  boxStyling?: CSSProperties;
}

export default function Modal({isOpen, toggle, buttonText, buttonStyling, boxStyling = ModalBox, children}: PropsWithChildren<ModalType>) {
  return (
    <>
      {isOpen && (
        <div style={ModalOverlay} onClick={toggle} aria-hidden>
          <div style={boxStyling} onClick={(e) => e.stopPropagation()} aria-hidden>
            {!buttonText &&
              <button style={buttonStyling} className={buttonStyling ? "" : "usa-button"} onClick={toggle}>
                <Close fill={"black"} height={13} />
              </button>
            }
            <div style={ModalContent}>{children}</div>
            {buttonText &&
              <button style={buttonStyling} className={buttonStyling ? "" : "usa-button"} onClick={toggle}>{buttonText}</button>
            }
          </div>
        </div>
      )}
    </>
  );
}